import React from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {

    House,

    Package,

    Wallet,

    User

} from "lucide-react";

import "./DeliveryBottomNav.css";

function DeliveryBottomNav() {

    const navigate = useNavigate();

    const location = useLocation();

    const menu = [

        {
            name: "Home",
            icon: House,
            path: "/delivery/home"
        },

        {
            name: "Orders",
            icon: Package,
            path: "/delivery/orders"
        },

        {
            name: "Earnings",
            icon: Wallet,
            path: "/delivery/earnings"
        },

       

    ];

    return (

        <div className="delivery-bottom-nav">

            {

                menu.map((item) => {

                    const Icon = item.icon;

                    const active =
                        location.pathname === item.path;

                    return (

                        <button

                            key={item.name}

                            className={
                                active
                                    ? "bottom-item active"
                                    : "bottom-item"
                            }

                            onClick={() =>
                                navigate(item.path)
                            }

                        >

                            <Icon size={22} />

                            <span>

                                {item.name}

                            </span>

                        </button>

                    );

                })

            }

        </div>

    );

}

export default DeliveryBottomNav;